
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/search",
      function () {
        return require("private-next-pages/hospitals/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals/search"])
      });
    }
  